/** Passwortrichtlinie gemäß docs/SPEC.md §7; gilt für Anlage und Änderung. */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 200;
/**
 * Karenzzeit für das erneute Vorzeigen eines bereits rotierten Refresh-Tokens.
 * Mehrere Browser-Tabs erneuern die Sitzung gleichzeitig; ohne Karenz würde die
 * Wiederverwendungserkennung diesen Wettlauf als Diebstahl werten und den
 * Benutzer abmelden. Ein echter Token-Diebstahl wird außerhalb dieses Fensters
 * unverändert erkannt und beendet die gesamte Token-Familie.
 */
export const REFRESH_TOKEN_REUSE_GRACE_MS = 20_000;
export const PASSWORD_RULES = ['length', 'uppercase', 'lowercase', 'digit', 'special'];
const RULE_PATTERNS = {
    uppercase: /[A-ZÄÖÜ]/u,
    lowercase: /[a-zäöüß]/u,
    digit: /\d/u,
    special: /[^A-Za-z0-9ÄÖÜäöüß]/u,
};
export function failedPasswordRules(password) {
    const failed = [];
    if (password.length < PASSWORD_MIN_LENGTH) {
        failed.push('length');
    }
    for (const rule of ['uppercase', 'lowercase', 'digit', 'special']) {
        if (!RULE_PATTERNS[rule].test(password)) {
            failed.push(rule);
        }
    }
    return failed;
}
export function isPasswordCompliant(password) {
    return failedPasswordRules(password).length === 0;
}
const SEQUENCES = ['0123456789', 'abcdefghijklmnopqrstuvwxyz', 'qwertzuiop', 'qwertyuiop'];
function hasSequence(value) {
    const lower = value.toLowerCase();
    for (const sequence of SEQUENCES) {
        for (let index = 0; index + 4 <= sequence.length; index += 1) {
            if (lower.includes(sequence.slice(index, index + 4))) {
                return true;
            }
        }
    }
    return false;
}
function hasRepetition(value) {
    return /(.)\1{2,}/u.test(value);
}
/**
 * Heuristische Stärkebewertung von 0 (sehr schwach) bis 4 (sehr stark).
 * Bewertet Länge, Zeichenklassen sowie erkennbare Muster und Wiederholungen.
 */
export function passwordStrengthScore(password) {
    if (password.length === 0) {
        return 0;
    }
    const classes = ['uppercase', 'lowercase', 'digit', 'special'].filter((rule) => RULE_PATTERNS[rule].test(password)).length;
    const uniqueRatio = new Set(password).size / password.length;
    let score = 0;
    if (password.length >= 8) {
        score += 1;
    }
    if (password.length >= PASSWORD_MIN_LENGTH) {
        score += 1;
    }
    if (password.length >= 16) {
        score += 1;
    }
    if (classes >= 3) {
        score += 1;
    }
    if (classes === 4 && uniqueRatio > 0.6) {
        score += 1;
    }
    if (hasSequence(password) || hasRepetition(password)) {
        score -= 2;
    }
    return Math.min(Math.max(score, 0), 4);
}
/** Sicherheitsereignisse des Protokolls; Spiegel des Prisma-Enums. */
export const SECURITY_EVENTS = [
    'LOGIN_SUCCESS',
    'LOGIN_FAILED',
    'LOGOUT',
    'TWO_FACTOR_ENABLED',
    'TWO_FACTOR_DISABLED',
    'TWO_FACTOR_FAILED',
    'TWO_FACTOR_METHOD_CHANGED',
    'TWO_FACTOR_RESET',
    'EMAIL_CHANGED',
    'PASSWORD_CHANGED',
    'PASSWORD_RESET',
    'ACCOUNT_LOCKED',
    'ACCOUNT_UNLOCKED',
    'ROLE_UPDATED',
    'PERMISSIONS_MODIFIED',
    'SESSION_REVOKED',
    'USER_CREATED',
    'USER_UPDATED',
    'BANKING_CONNECTION_STARTED',
    'BANKING_CALLBACK_ACCEPTED',
    'BANKING_CALLBACK_REJECTED',
    'BANKING_CONNECTION_SUSPENDED',
    'BANKING_CONNECTION_REVOKED',
    'BANKING_WEBHOOK_ACCEPTED',
    'BANKING_WEBHOOK_REJECTED',
];
export const TWO_FACTOR_CODE_LENGTH = 6;
export const TWO_FACTOR_BACKUP_CODE_COUNT = 10;
export const TWO_FACTOR_BACKUP_CODE_LENGTH = 10;
/** Gültigkeit des Zwischentokens zwischen Passwortprüfung und TOTP-Eingabe. */
export const TWO_FACTOR_CHALLENGE_TTL_SECONDS = 300;
export const TWO_FACTOR_ISSUER = 'ERP';
export const USER_SORT_FIELDS = [
    'email',
    'lastName',
    'roleName',
    'isActive',
    'lastLoginAt',
    'createdAt',
];
export const SECURITY_LOG_PAGE_SIZE = 50;
//# sourceMappingURL=security.js.map